import sumoLogo from '../images/sumo_logo.png'
import { Dialog, DialogActions, DialogBody, DialogDescription, DialogTitle } from '../components/dialog'

import { Button } from '../components/button'
import { PlusIcon } from '@heroicons/react/16/solid'

import { Input } from '../components/input'
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../components/table'
import { useState, useEffect, useRef } from 'react'
import { Badge } from '../components/badge'

import { Loader } from '../components/loader';
import { useNavigate, useLocation } from 'react-router-dom';

import { AuthLayout } from '../components/auth-layout'
import { Avatar } from '../components/avatar'
import { Heading } from '../components/heading'

import config from '../config.js'

import { ErrorNotification, SuccessNotification } from '../components/notification';
import { useAlert } from "../components/customAlert";

export default function ListCompanies() {
	const { showAlert } = useAlert();
	const navigate = useNavigate();
	const { state } = useLocation();
	const [products, setProducts] = useState([]);
	const [selectedIds, setSelectedIds] = useState([]);
	const [page, setPage] = useState(1);
	const limit = 10;
	const [total, setTotal] = useState(0);
	const [popupMessage, setPopupMessage] = useState('');
	const [popupHeading, setPopupHeading] = useState('');
	const [loading, setLoading] = useState(false);
	const [confirmed, setConfirmed] = useState(false);//for confirmation
	let [isOpen, setIsOpen] = useState(false);
	let [isOpenConfirm, setIsOpenConfirm] = useState(false);
	const [selectedCompName, setSelectedCompName] = useState('');
	const [selectedCompCntry, setSelectedCompCntry] = useState('');
	const [selectedCompPrdt, setSelectedCompPrdt] = useState('');
	const [selectedCompMail, setSelectedCompMail] = useState('');

	const [successMsg, setSuccessMsg] = useState('');
  	const [showSuccessBox, setShowSuccessBox] = useState(false);
  	const [errorMsg, setErrorMsg] = useState('');
  	const [showErrorBox, setShowErrorBox] = useState(false);
	
	const didFetch = useRef(false);
	const attemptsRef = useRef(0);

	useEffect(() => {
	  if (!state.gmcEmail) return;
	
	  //let intervalId;
	  let timeoutId;
  	  let isStopped = false;
	  const abortController = new AbortController();
	  	
	  const fetchProducts = async (pageNum) => {
		 if (isStopped) return;
		setLoading(true);
		try {
		  const ids = state.selectedIds.join(",");
		  const res = await fetch(
			`${config.apiPath}/gmc-setup/gmc-handler.php?process=get_importing_list&gmc_mail_id=${encodeURIComponent(state.gmcEmail)}&ids=${ids}`,
			{ credentials: 'include', signal: abortController.signal }
		  );
		  const data = await res.json();
	
		  //setProducts(data.products);
		 
		 setProducts((prevProducts) => {
			 //clone previous state
			const updated = { ...prevProducts };
		  
			// loop over ajax response
			Object.values(data.products).forEach((prod) => {
			  updated[prod.dataSourceId] = prod; // overwrite only this one
			});
		  
			return updated;
		  }); 
		  
		  setTotal(data.total);
	
		  // ✅ Stop polling if condition is met
		  if (data.is_completed=='yes') {
			isStopped = true;
			//clearInterval(intervalId);
			
			const response = await fetch(`${config.apiPath}register_login.php?email=${encodeURIComponent(state.gmcEmail)}`, {
                //method: 'POST',
				credentials: 'include',                
            });

            const result = await response.json();
            console.log('Server response:', result);
            if (result.status === 'success') {
                //navigate('/dashboard');
                window.location.href = `/${config.appPath}dashboard`;
            } else {
                //setServerError(result.message || 'Login failed.');
                showAlert(result.message, "Error" , "error",3000);
            }
			showAlert("Sync process completed", "" , "success",3000);					
			return; // don't schedule next request
		  }
		  
		  attemptsRef.current++;
		  
		  /*if (attemptsRef.current >= 100) {
			isStopped = true;
			//clearInterval(intervalId);
			setErrorMsg('Maximum try reached!');
			setShowErrorBox(true);
			setTimeout(() => {
				setShowErrorBox(false);
				setErrorMsg("");
				
			}, 3000);
			return;
		  }*/
		  
		} catch (error) {
		  	if (error.name !== "AbortError") {
        		console.error("Fetch error", error);
      		}
		  //clearInterval(intervalId); // stop if error occurs
		  isStopped = true;
		  
		} finally {
		  setLoading(false);
		  	if (!isStopped) {
        		timeoutId = setTimeout(() => fetchProducts(pageNum), 3000);
      		}
		}
	  };
	
	  // first call immediately
	  fetchProducts(page);
	
	  // then poll every 3 seconds
	 // intervalId = setInterval(() => {
		//fetchProducts(page);
	  //}, 5000);
	
	  // cleanup on unmount or when gmcEmail changes
	   return () => {
    	isStopped = true;
    	abortController.abort(); // cancel ongoing request
    	clearTimeout(timeoutId); // cancel scheduled next run
  		};
	
	 }, [state.gmcEmail, page]);	
	
	return (
<AuthLayout>
	<SuccessNotification showSuccessBox={showSuccessBox} successMsg={successMsg} setShowSuccessBox={setShowSuccessBox} />
    <ErrorNotification showErrorBox={showErrorBox} errorMsg={errorMsg} setShowErrorBox={setShowErrorBox} />
	<div className="grid grid-cols-1 gap-x-8 gap-y-2 !align-center !content-center">
		<div className="flex justify-center"><Avatar square className="!size-20" src={sumoLogo} /></div>
		<Heading className="text-center !text-4xl py-2">Welcome to FeedSumo</Heading>
		<Heading className="text-center !text-1xl ">Let's get you started</Heading>
		<Heading className="text-center !text-1xl whitespace-pre-line">
			We are importing and analysing data. You can close this window <br /> 
			We'll email you when all it's done. <br />
			Of course, if you're nosy you can see what we're doing below.
		</Heading>
				
		<Table className="max-h-[280px] [--gutter:--spacing(6)] overflow-x-auto overflow-y-auto mt-4 ">
			<TableHead>
				<TableRow>
					<TableHeader>Feed ID</TableHeader>
					<TableHeader>Merchant Name</TableHeader>
					<TableHeader>Import Products</TableHeader>
					{/*<TableHeader>Run Audit</TableHeader>*/}
				</TableRow>
			</TableHead>
			{/*loading && <Loader />*/}
			<TableBody>
				{total > 0 ?( 
					Object.values(products).map((prod) => (
					<TableRow key={prod.dataSourceId}>
						<TableCell>{prod.dataSourceId}</TableCell>
						<TableCell>{prod.merchant_name}</TableCell>
						<TableCell>
							<Badge color={prod.importStatus === "In progress" ? "blue" : prod.importStatus === "Not started" || prod.importStatus === "Error" ? "red" : "green"}>
							{prod.importStatus}{prod.importStatus === "In progress" && prod.importPercentage > 1 ? "("+`${prod.importPercentage}`+"%)" : ""}</Badge>
						</TableCell>
					</TableRow>))
				):(<TableRow><TableCell>No Accounts Found</TableCell></TableRow>)}
			</TableBody>
		</Table>
	</div>
</AuthLayout>
);
}